import React from 'react';
import { Link } from 'react-router-dom';
import AutodeskLogo from '../../assets/mycompany.png/Autodesk.png';
import AvanadeLogo from '../../assets/mycompany.png/avanade.png';
import CloudflareLogo from '../../assets/mycompany.png/cloudflare.png';
import CognizantLogo from '../../assets/mycompany.png/Cognizant.png';
import EquinixLogo from '../../assets/mycompany.png/Equinix.png';
import GlobalFoundriesLogo from '../../assets/mycompany.png/globalfounderies.png';
import OrganonLogo from '../../assets/mycompany.png/organon (1).png';
import AWSLogo from '../../assets/mycompany.png/aws.png';
import JohnsonControlsLogo from '../../assets/mycompany.png/JohnsonControls.png';
import MicrosoftLogo from '../../assets/mycompany.png/Microsoft.png';

const companies = [
  { name: 'Autodesk', logo: AutodeskLogo, slug: 'autodesk' },
  { name: 'Avanade', logo: AvanadeLogo, slug: 'avanade' },
  { name: 'Cloudflare', logo: CloudflareLogo, slug: 'cloudflare' },
  { name: 'Cognizant', logo: CognizantLogo, slug: 'cognizant' },
  { name: 'Equinix', logo: EquinixLogo, slug: 'equinix' },
  { name: 'GlobalFoundries', logo: GlobalFoundriesLogo, slug: 'globalfoundries' },
  { name: 'Organon', logo: OrganonLogo, slug: 'organon' },
  { name: 'Amazon Web Services', logo: AWSLogo, slug: 'amazon-web-services' },
  { name: 'Johnson Controls', logo: JohnsonControlsLogo, slug: 'johnson-controls' },
  { name: 'Microsoft', logo: MicrosoftLogo, slug: 'microsoft' },
];

const FeaturedCompanies = () => {
  const duplicatedCompanies = [...companies, ...companies];

  return (
    <section className="bg-white py-12 sm:py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
          Meet Our Companies that Care™
        </h2>
        <div className="relative overflow-hidden">
          <div className="flex animate-infinite-scroll">
            {duplicatedCompanies.map((company, index) => (
              <div key={index} className="flex-shrink-0 mx-8 w-48 h-20 flex items-center justify-center">
                <Link to={`/companies/${company.slug}`} className="block">
                  <img 
                    src={company.logo} 
                    alt={company.name} 
                    className="max-h-12 max-w-full object-contain transition-all duration-300"
                  />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedCompanies; 